import { ReduxModule } from '../../BaseAppProvider/BaseAppProvider';
import { themesReducer } from './reducers';
import rootSaga from './sagas';

export const getWithDevExtremeModule = (): ReduxModule => ({
  id: 'withDevExtreme',
  reducerMap: {
    themes: themesReducer
  },
  sagas: [rootSaga]
});
